'use client';

import Button from '@/components/Button';
import ContactCTA from '@/components/ContactCTA';
import ContactNew from '@/components/ContactNew';
import FacilitiesTabs from '@/components/FacilitiesTabs';
import FrequentlyAskedQuestions from '@/components/FrequentlyAskedQuestions';
import Header from '@/components/Header';
import SectionTitle from '@/components/SectionTitle';
import { Markdown } from '@/lib/markdown';
import IFacilitiesPage from '@/models/facilities';

export default function FacilitiesPage(props: {
	facilitiesPage?: IFacilitiesPage;
	preview?: boolean;
}) {
	const facilitiesPage = props.facilitiesPage;

	return (
		<section className="-mt-16">
			<div className="z-20 relative bg-contain xl:bg-cover bg-white text-white bg-bottom  flex flex-col">
				<Header
					small
					title={facilitiesPage?.title}
					headerSliderImagesCollection={{ items: [facilitiesPage?.image] }}
				/>
			</div>

			<FacilitiesTabs
				title={facilitiesPage?.facilitiesTitle}
				facilities={facilitiesPage?.ourFacilitiesCollection?.items}
			/>

			{!!facilitiesPage?.faqsCollection?.items?.length ? (
				<div className="z-10 relative py-12  md:py-32 flex flex-col overflow-clip bg-white">
					<FrequentlyAskedQuestions
						faqs={facilitiesPage?.faqsCollection?.items}
						title={'Frequently Asked Questions'}
					/>
				</div>
			) : null}

			<ContactCTA
				title={facilitiesPage?.callToAction?.title}
				description={
					facilitiesPage?.callToAction?.contentDescription && (
						<Markdown content={facilitiesPage.callToAction.contentDescription} />
					)
				}
				buttons={facilitiesPage?.callToAction?.buttonsCollection?.items}
			/>
		</section>
	);
}
